import { NgModule, ModuleWithProviders, SkipSelf, Optional, NgModuleRef, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { SwiftForwardingApiClient } from './services';
import { CitiServiceConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    citiServiceConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    citiServiceConfig: CitiServiceConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('CitiServiceModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [SwiftForwardingApiClient],
})
export class CitiServiceModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => CitiServiceConfig
  ): ModuleWithProviders<CitiServiceModule> {
    return {
      ngModule: CitiServiceModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: CitiServiceModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CitiServiceModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => CitiServiceConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new CitiServiceConfig(cfgMgr.withBase(cfgMgr.getRawConfig('citiServiceConfig')));
    cfgMgr.addApiConfig('citiServiceConfig', config);
  }
}
